import ConfigPriorityTimeTask from "../model/ConfigPriorityTimeTask";
import { GetOptions, promiseRequest } from "./ServiceApi";
import { ServiceApi } from "./ServiceApiWithLoading";

export default class ConfigPriorityTimeTaskApi extends ServiceApi<ConfigPriorityTimeTask>{

    constructor() {
        super('configPriorityTimeTask');
    }

    async getConfigPriorityTimeTask(options: GetOptions<ConfigPriorityTimeTask> = {}): Promise<ConfigPriorityTimeTask> {
        return this.promiseWithLoading(super.getById(1, options));
    }

    async saveConfigPriorityTimeTask(data: Partial<ConfigPriorityTimeTask>) {
        return this.promiseWithLoading(super.update(1, data));
    }
}